export default [
    {
        path: '/project',
        name: 'projects',
        component: () => import('../views/project/ProjectsView.vue'),
        meta: {
            requiresAuth: true
        },
    },
    {
        path: '/profile',
        name: 'profile',
        component: () => import('../views/ProfileView.vue'),
        meta: {
            requiresAuth: true
        },
    },
    {
        path: '/project/:id',
        name: 'project',
        component: () => import('../views/project/ProjectView.vue'),
        meta: {
            requiresAuth: true
        },
    },
    {
        path: '/create-project',
        name: 'create-project',
        component: () => import('../views/project/CreateProject.vue'),
        meta: {
            requiresAuth: true
        },
    },
    {
        path: '/new-empty-project',
        name: 'new-empty-project',
        component: () => import('../views/project/NewEmptyProject.vue'),
        meta: {
            requiresAuth: true
        },
    },
    {
        path: '/new-project-from-smeta',
        name: 'new-project-from-smeta',
        component: () => import('../views/project/NewProjectFromSmeta.vue'),
        meta: {
            requiresAuth: true
        },
    },
    {
        path: '/project/:id/stage/create',
        name: 'create-stage',
        component: () => import('../views/stage/CreateStage.vue'),
        meta: {
            requiresAuth: true
        },
    },
    {
        path: '/project/:id/members',
        name: 'members',
        component: () => import('../views/project/member/MembersProject.vue'),
        meta: {
            requiresAuth: true
        },
    },
]
